import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Improve from './modal/Improve';
// 员工搜索组件
import StaffSearch from '@/components/staff-search';
// 接口地址api
import { getCode, getCreateCode, getPendingList, switchstate, inviteApproval } from 'api/settings';
export default {
  components: {
    Improve: Improve,
    StaffSearch: StaffSearch
  },
  data: function data() {
    return {
      value: '',
      radio: '',
      status: true,
      form: {},
      tableData: [],
      // 邀请页面数据
      invite: {
        openState: false
      },
      isImprove: false,
      // 申请处理状态  通过 拒绝 屏蔽
      approvalState: new Map([['1', '364'], ['2', '365'], ['3', '366']])
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      // 获取申请人列表
      this.handleGetPendingList();
      this.handlerGetCode();
    },
    // 确认拒绝
    confirmRelod: function confirmRelod(item) {
      var _this = this;
      this.$confirm(this.$t('369', {
        name: item.name
      }), this.$t('367'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        inviteApproval(_objectSpread(_objectSpread({}, item), {}, {
          state: 2
        })).then(function (res) {
          _this.$message.success(_this.$t('886'));
          _this.handleGetPendingList();
        });
      });
    },
    // 确认屏蔽
    confirmShield: function confirmShield(item) {
      var _this2 = this;
      this.$confirm(this.$t('370'), this.$t('368'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        inviteApproval(_objectSpread(_objectSpread({}, item), {}, {
          state: 3
        })).then(function (res) {
          _this2.$message.success(_this2.$t('886'));
          _this2.handleGetPendingList();
        });
      });
    },
    cancelShield: function cancelShield(item) {
      var _this3 = this;
      // 取消屏蔽
      inviteApproval(_objectSpread(_objectSpread({}, item), {}, {
        state: 4
      })).then(function (res) {
        _this3.$message.success(_this3.$t('886'));
        _this3.handleGetPendingList();
      });
    },
    // 切换页面
    changeStatus: function changeStatus(val) {
      this.status = val;
    },
    // 获取邀请码
    handlerGetCode: function handlerGetCode() {
      var _this4 = this;
      getCode().then(function (res) {
        var data = res.data && res.data.data ? res.data.data : 100;
        if (data) {
          _this4.invite = _objectSpread(_objectSpread({}, _this4.invite), res.data.data);
          _this4.invite.openState = Number(data.state) !== 0;
        }
      });
    },
    // 更新邀请码
    handleCode: function handleCode() {
      var _this5 = this;
      getCreateCode().then(function (res) {
        var data = res.data && res.data.data ? res.data.data : 100;
        if (data) {
          _this5.invite = _objectSpread(_objectSpread({}, _this5.invite), res.data.data);
          _this5.invite.openState = Number(data.state) !== 0;
        }
      });
    },
    // 复制验证码
    copyCode: function copyCode() {
      var oInput = document.createElement('input');
      oInput.value = this.invite.code;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      oInput.className = 'oInput';
      oInput.style.display = 'none';
      document.body.removeChild(oInput);
      this.$message({
        message: this.$t('888'),
        type: 'success'
      });
    },
    // 申请人列表
    handleGetPendingList: function handleGetPendingList() {
      var _this6 = this;
      getPendingList(this.form).then(function (res) {
        _this6.tableData = res.data.data;
      });
    },
    // 同意
    confirmAgree: function confirmAgree(item) {
      var _this7 = this;
      this.isImprove = true;
      this.$nextTick(function () {
        // console.log(this.$refs);
        _this7.$refs.improve.init(item);
      });
    },
    handlerSwitchChange: function handlerSwitchChange() {
      switchstate();
    }
  }
};